import React from 'react'
import { Col, Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import CustomButton from 'components/atoms/CustomButton';
import { formatDate } from 'lib/utils';
import { SUBSCRIPTION_STATUS } from 'constant';

const CompanySubscriptionInfo = ({ data, onChangePlan }) => {


  const { t, i18n } = useTranslation();




  return (
    <Row className="mb-4 pt-6">
      <Col span={6} className="pl-4 pr-2">
        <Typography.Title className="text-h2 font-manrope !text-white">
          {t("Plans.Subscription")}
        </Typography.Title>
      </Col>
      <Col span={6} className="px-2">
        <div className="mb-8">
          <div>
            <Typography.Text className="font-manrope font-semibold text-[#7A7A7A] text-md">
              {t('Plans.PlanType')}
            </Typography.Text>
          </div>
          <div>
            <Typography.Text className="font-manrope font-medium text-[#FFF] text-lg">
              {data?.subscription?.payment_type === 'YEARLY' ? t('Plans.Yearly') : t('Plans.Monthly')}
            </Typography.Text>
          </div>

        </div>
        <div className="mb-8">
          <div>
            <Typography.Text className="font-manrope font-semibold text-[#7A7A7A] text-md">
              N.{t("Plans.Sits")}
            </Typography.Text>
          </div>
          <div>
            <Typography.Text className="font-manrope font-medium text-[#FFF] text-lg">
              {data?.subscription?.seat_number}
            </Typography.Text>
          </div>
        </div>
        <div className="mb-8">
          <div>
            <Typography.Text className="font-manrope font-semibold text-[#7A7A7A] text-md">
              {`Status ${t('Plans.Subscription')}`}
            </Typography.Text>
          </div>
          <div>
            <Typography.Text className={`${data?.subscription?.status === SUBSCRIPTION_STATUS.TRIAL || data?.subscription?.status === SUBSCRIPTION_STATUS.EXPIRED || data?.subscription?.status === SUBSCRIPTION_STATUS.NOT_PAYED || data?.subscription?.status === SUBSCRIPTION_STATUS.CANCELED ? 'text-[#E53E3E] font-manrope font-medium text-lg' : 'text-white font-manrope font-medium text-[#FFF] text-lg'}`}>


              {data?.subscription?.status === SUBSCRIPTION_STATUS.TRIAL ? SUBSCRIPTION_STATUS.TRIAL :
                data?.subscription?.status === SUBSCRIPTION_STATUS.NOT_PAYED ? t('Pay.Unpaid') :
                  data?.subscription?.status === SUBSCRIPTION_STATUS.EXPIRED ? `${t('Pay.Expired')}` :
                    data?.subscription?.status === SUBSCRIPTION_STATUS.CANCELED ? t('Plans.Deleted') :
                      data?.subscription?.status === SUBSCRIPTION_STATUS.ACTIVE && data?.subscription?.next_payment_date ? t('Plans.Active')
                        : t('Plans.ActivePaymentExternal')
              }
            </Typography.Text>
          </div>
        </div>
      </Col>
      <Col span={6} className="px-2">
        <div className="mb-8">
          <div>
            <Typography.Text className="font-manrope font-semibold text-[#7A7A7A] text-md">
              {t("Plans.Price")}
            </Typography.Text>
          </div>
          <div>
            <Typography.Text className="font-manrope font-medium text-[#FFF] text-lg">
              {parseFloat(data?.subscription?.total).toFixed(2)} €
            </Typography.Text>
          </div>
        </div>
        <div className="mb-8">
          <div>
            <Typography.Text className="font-manrope font-semibold text-[#7A7A7A] text-md">
              {t("Plans.NextCharge")}
            </Typography.Text>
          </div>
          <div>
            <Typography.Text className="font-manrope font-medium text-[#FFF] text-lg">
              {formatDate(data?.subscription?.next_payment_date)}
            </Typography.Text>
          </div>
        </div>

      </Col>



      <Col span={6} className="pr-4 pl-2 text-right">
        <div className="mb-8">
          {data?.is_active_flag && data?.subscription?.status !== SUBSCRIPTION_STATUS.CANCELED && (
            <CustomButton
            buttonColor={"secondary"}
            onClick={() => {
              if (!data?.subscription) {
                return false
              }
              onChangePlan();
            }}
          >{t("Plans.Change Plan")}</CustomButton>
          )}
          
        </div>
      </Col>
    </Row>
  )
}

export default CompanySubscriptionInfo
